import { useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "sonas-theme-mode";

export const THEME_MODES = ["light", "dark", "system"];

const getSystemPreference = () => {
  if (typeof window === "undefined") {
    return "dark";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

const getInitialMode = () => {
  if (typeof window === "undefined") {
    return "dark";
  }

  const storedValue = window.localStorage.getItem(STORAGE_KEY);
  return THEME_MODES.includes(storedValue) ? storedValue : "dark";
};

export const useSonasTheme = () => {
  const [themeMode, setThemeMode] = useState(getInitialMode);
  const [systemTheme, setSystemTheme] = useState(getSystemPreference);

  const resolvedTheme = useMemo(() => {
    if (themeMode === "system") {
      return systemTheme;
    }

    return themeMode;
  }, [systemTheme, themeMode]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const updateSystemTheme = (event) => {
      setSystemTheme(event.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", updateSystemTheme);

    return () => {
      mediaQuery.removeEventListener("change", updateSystemTheme);
    };
  }, []);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, themeMode);
  }, [themeMode]);

  useEffect(() => {
    const rootElement = document.documentElement;
    rootElement.dataset.theme = resolvedTheme;
    rootElement.classList.toggle("dark", resolvedTheme === "dark");
  }, [resolvedTheme]);

  return {
    themeMode,
    resolvedTheme,
    setThemeMode,
  };
};
